import Swiper from 'swiper/swiper-bundle';
var throttle = require('lodash/throttle');

$(function () {
    const state = {
        swiperInstance: null,
        isInitialized: false
    };

    function enableCarousel () {
        if (state.swiperInstance) {
            return state.swiperInstance;
        }

        const $swiperWrapper = $('.swiper .swiper-wrapper');
        $swiperWrapper.empty();

        // Collect images from both first-row and remaining-images
        $('.first-row img:not(.hide), .first-row .video-wrapper, .remaining-images img').each(function () {
            const $slide = $('<div class="swiper-slide js-linkModalProductImageCarousel"></div>').append($(this).clone());
            $swiperWrapper.append($slide);
        });

        $('.swiper').addClass('ready').show();

        state.swiperInstance = new Swiper('.swiper', {
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }
        });

        state.isInitialized = true;

        return state.swiperInstance;
    }

    function disableCarousel () {
        if (!state.swiperInstance || !state.isInitialized) {
            return;
        }

        if (state.swiperInstance && typeof state.swiperInstance.destroy === 'function' && !state.swiperInstance.destroyed) {
            state.swiperInstance.destroy(true, true);
        }
        $('.swiper').removeClass('ready').hide();
        state.swiperInstance = null;
        state.isInitialized = false;
    }

    function checkLayout () {
        const isMobile = !Foundation.MediaQuery.atLeast('medium');
        
        if (isMobile && !state.isInitialized) {
            enableCarousel();
        } else if (!isMobile && state.isInitialized) {
            disableCarousel();
        }
    }

    checkLayout();
    
    $(window).on('resize', throttle(checkLayout, 500));
});
